import React from "react";
import InfoCard from "../layout_reuse/InfoCard";
import CardContainer from "../layout_reuse/CardContainer";
import VenmoPng from "../../svg/venmo_qr_code.png";
import "./TipJarPage.css";

interface Props {}

const DESKTOP_LINK =
  "https://account.venmo.com/pay?recipients=CurtisMakesThings&audience=private&note=chordnoodler.com%20tip%20jar%20woohoo!";
/** Venmo deeplinking is fubar, so play it safe on narrow viewports */
const MOBILE_LINK = "https://venmo.com/u/CurtisMakesThings";
const isMobile = window.screen.width < 600;

function TipJarPage(_props: Props) {
  const SITE_LINK = isMobile ? MOBILE_LINK : DESKTOP_LINK;
  return (
    <CardContainer>
      <InfoCard>
        <div className="tip-jar-inner-card">
          <h2>Tip Jar</h2>

          <p>If this site is useful to you, please consider donating to my rice and beans fund.</p>
          <p>
            @CurtisMakesThings via the{" "}
            <a href={SITE_LINK} target="_blank" rel="noreferrer">
              Venmo website
            </a>
            , or by scanning the QR code below.
          </p>

          <div className="venmo-png-box">
            <span className="venmo-png-img-span">
              <img src={VenmoPng} alt="CurtisMakesThings is my venmo 'business' account."></img>
            </span>
          </div>
          <p>This is of course not tax deductible. I think I'm required to say so.</p>
          <p>But I'm grateful to have been able to share this, and I hope you enjoy it!</p>
        </div>
      </InfoCard>
    </CardContainer>
  );
}

export default TipJarPage;
